// if(objects.is_lieux){

//     let cords = document.querySelectorAll(".map")
//     let coords = Array.from(cords)
  
//     for(let i = 0; i < coords.length; i++){
  
//         coords[i].addEventListener("click", () => {
//             window.location = "https://maps.google.com/?ll=" + coords[i].getAttribute('data-url')
//         })
//     }
// }